export const styleIf = (condition, style) => condition ? style : ''

export default { styleIf }
